export default __webpack_public_path__ + "static/media/i035vp.9288bada.webp";